import { render } from "./FilterTab.vue?vue&type=template&id=583e8d9b&scoped=true"
import script from "./FilterTab.vue?vue&type=script&lang=js"
export * from "./FilterTab.vue?vue&type=script&lang=js"

import "./FilterTab.vue?vue&type=style&index=0&id=583e8d9b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583e8d9b"]])

export default __exports__